import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { actions as loginActions } from "../login/Login.redux";
import { actions as locationActions } from "../location";
import {
  selectModalSignupShow,
  selectSignupFooterShow,
} from "../modal-signup/ModalSignup.helpers";

import Page from "./Page.view";

const mapStateToProps = state => {
  return {
    authenticated: !!state.login.auth.expires,
    user: state.login.user,
    hasCompared: !!state.comparedListings.length,
    hasSelectedFiles:
      !!state.selectFilesChosen && !!state.selectFilesChosen.length,
    targetDevice: state.targetDevice,
    locations: state.locations,
    locationsError: state.locationsError,
    locationsLoading: state.locationsLoading,
    modalSignupShow: selectModalSignupShow(state),
    signupFooterShow: selectSignupFooterShow(state),
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(loginActions.logout()),
  locationsFetch: () => dispatch(locationActions.fetch()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));
